import styled from 'styled-components';
import { Text18 } from '../Text18';

export const BackTo = styled(Text18)`
  color: ${({ theme }) => theme.colors.accentBlue};
  display: flex;
  align-items: center;
  position: absolute;
  cursor: pointer;
  top: 50%;
  transform: translate(0, -50%);
`;

